module.exports = __webpack_public_path__ + "img/catwrench.5c105158.jpg";